<template>
  <div class="wrapper withdraw-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>{{ $t("WITHDRAW") }}</h1>
          <div class="balance">
            <h2>{{ $t("Possible withdrawal amount") }}</h2>
            <div class="total-amount"><span>100</span> USD</div>
            <p>( 0.000011 BTC )</p>
          </div>
          <div class="form">
            <form>
              <div class="error-msg">
                {{ $t("※Minimum withdrawal amount 300USD") }}
              </div>
              <div class="input-area">
                <label class="label" for="amount">
                  <input
                    type="text"
                    name=""
                    id="amount"
                    placeholder=" "
                    v-model.number="amountBtc"
                  />
                  <span class="group-label">{{
                    $t("Enter the amount you wish to withdraw.")
                  }}</span>
                  <span class="upper-amount">(0.00000111 BTC)</span>
                </label>
                <span class="circle" v-bind:class="{ done: hasBtcAmount }">
                  <span class="bar"></span>
                </span>
              </div>
              <div class="input-area">
                <label class="label" for="address">
                  <input
                    type="text"
                    name=""
                    id="address"
                    placeholder=" "
                    v-model="addressBtc"
                  />
                  <span class="group-label">{{
                    $t("Enter your BTC address.")
                  }}</span>
                </label>
                <span class="circle" v-bind:class="{ done: hasBtcAddress }">
                  <span class="bar"></span>
                </span>
              </div>
              <div class="all-amount">
                <p>{{ $t("Amount to be withdrawn") }}</p>
                <div class="number">
                  <span v-if="!amountBtc">- - - - - -</span>
                  <span else>{{ amountBtc }}</span>
                  BTC
                </div>
              </div>
              <div class="btn">
                <button
                  type="button"
                  class="link-over"
                  id="send_btn"
                  v-on:click="show"
                  v-bind:disabled="!hasBtcChecked"
                >
                  {{ $t("Withdrawal") }}
                </button>
              </div>
            </form>
          </div>
          <div class="table">
            <h2>{{ $t("Withdrawal history") }}</h2>
            <table>
              <tr>
                <th>{{ $t("Date") }}</th>
                <th>{{ $t("Type") }}</th>
                <th>{{ $t("Amount") }}</th>
                <th>{{ $t("Status") }}</th>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>BTC</td>
                <td>0.01BTC</td>
                <td>{{ $t("Not approved") }}</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>BTC</td>
                <td>0.01BTC</td>
                <td>{{ $t("Approved") }}</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>BTC</td>
                <td>0.01BTC</td>
                <td>{{ $t("Not approved") }}</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>BTC</td>
                <td>0.01BTC</td>
                <td>{{ $t("Approved") }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <modal
      name="sendModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box">
        <div class="modal-ttl">
          <p>100 BTC<br />{{ $t("Are you sure you want to withdraw?") }}</p>
        </div>
        <div class="btn">
          <button
            v-on:click="certificationAction"
            type="button"
            class="link-over"
          >
            {{ $t("Complete withdrawal") }}
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="certificationModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box">
        <form>
          <div class="modal-ttl">
            <p>
              {{ $t("Two-factor authentication") }}
            </p>
            <div class="input-box">
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
            </div>
          </div>
          <div class="btn">
            <button v-on:click="hide2" type="button" class="link-over">
              {{ $t("Authenticate") }}
            </button>
          </div>
        </form>
      </div>
    </modal>

    <Footer title="WITHDRAWAL" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Withdraw",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Withdraw",
      amountBtc: "",
      addressBtc: "",
    };
  },
  methods: {
    show: function () {
      this.$modal.show("sendModal");
    },
    hide: function () {
      this.$modal.hide("sendModal");
    },
    show2: function () {
      this.$modal.show("certificationModal");
    },
    hide2: function () {
      this.$modal.hide("certificationModal");
    },
    certificationAction: function () {
      this.$modal.hide("sendModal");
      this.$modal.show("certificationModal");
    },
  },
  computed: {
    hasBtcAmount() {
      return this.amountBtc;
    },
    hasBtcAddress() {
      return this.addressBtc;
    },
    hasBtcChecked() {
      return this.amountBtc && this.addressBtc;
    },
  },
  mounted: function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");

    var ua = navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        var viewportContent = viewport.getAttribute("content");
        viewport.setAttribute(
          "content",
          viewportContent + ", user-scalable=no"
        );
      }
    }
  },
};
</script>
